import { WORKFLOWS_API } from 'modules/workflows/api/workflows-api'
import { WorkflowApiInterface } from 'modules/workflows/types/workflow-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useWorkflows({ limit, pagination }: SwrPaginationInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, WorkflowApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: workflows, mutate } = useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${WORKFLOWS_API}/list?pagination[limit]=${limit}`
    } else if (user && pagination.startFromId && limit) {
      return `${WORKFLOWS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    }
    return null
  }, fetcher)

  const { data: counter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${WORKFLOWS_API}/count?pagination[limit]`
    }
    return null
  }, baseFetcher)

  return { workflows, mutate, counter }
}
